import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, Card, CardActions, CardContent, Stack, Typography } from "@mui/material";
import { useAppBar } from "components";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "../../../models";

export function getToolsBreadcrumb(): Breadcrumb {
  return {
    title: "Tools",
    path: "/tools",
  };
}

export function ToolsPage() {
  const appBar = useAppBar();
  const navigate = useNavigate();

  useEffect(() => {
    appBar.setDefaults();
    appBar.setTitle("Tools");
  }, []);

  return (
    <Box sx={{ p: 2 }}>
      <Stack gap={2}>
        <Typography variant="body2" color="text.secondary">
          Select a tool to open a focused workflow.
        </Typography>

        <Stack direction="row" flexWrap="wrap" gap={2}>
          <Card sx={{ width: 360, borderRadius: 2 }} variant="outlined">
            <CardContent>
              <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 1 }}>
                <AnalyticsOutlinedIcon color="primary" />
                <Typography variant="h6">Child Age Analysis</Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                Determine caregiver-alone compliance for Illinois DCFS 406.13 using a scenario date and child roster.
              </Typography>
            </CardContent>
            <CardActions sx={{ px: 2, pb: 2 }}>
              <Button variant="contained" endIcon={<ArrowForwardIcon />} onClick={() => navigate("/tools/child-age-analysis")}>
                Open Tool
              </Button>
            </CardActions>
          </Card>
        </Stack>
      </Stack>
    </Box>
  );
}
